<template>
    <div>
        <section class="m_info"><!-- 音楽情報 -->
            <div class="cart_tit">{{ characters.cart_confirm }}</div>

            <div class="cart_subtit" v-if="otanishinjiro_access_status==0">{{ characters.purchase_items }}</div>
            <div class="cart_subtit" v-if="otanishinjiro_access_status==1">{{ characters.funding_amount }}</div>

            <div>
                <!-- 1アイテム -->
                <div v-for="item in cart" class="cart_box_par">
                    <div class="cart_box">
                        <div class="cb_item1"><img :src="'/item/image/'+item.item_id" alt="" width="100%"></div>
                        <div class="cb_item2">
                            <div class="cb_txt1" v-if="item_type_view_status == 1">{{ item.type_op + ' ' + item.on_sale_year }}</div>
                            <div class="cb_txt2">{{ item.title }}</div>
                            <div class="cb_txt3"></div>
                        </div>
                        <div class="cb_item3">
                            <div class="cb_item3_inner">
                                <p v-if="item.soldout_flag==0">{{ '￥' + item.price.toLocaleString() }}</p>
                                <p v-if="item.soldout_flag==1">{{ characters.soldout }}</p>
                            </div>
                            <div class="cb_item3_inner" v-if="item.type=='goods'"><p>{{ item.num }}</p></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="subtotal">
                <div>
                    <p v-if="otanishinjiro_access_status==0">{{ characters.subtotal }}({{ sum_num }}{{ characters.item_number }}) {{ '￥' + sum_yen.toLocaleString() }}({{ characters.tax_included }})</p>
                    <p v-if="otanishinjiro_access_status==1">{{ '￥' + sum_yen.toLocaleString() }}</p>
                </div>
                <div v-if="goods_flag==='1' && otanishinjiro_access_status!=1"><p>{{ characters.delivery_fee }} {{ '￥' + delivery_fee.toLocaleString() }}({{ characters.tax_included }})</p></div>
                <div v-if="goods_flag==='1' && otanishinjiro_access_status!=1"><p>{{ characters.total }} {{ '￥' + (sum_yen + delivery_fee).toLocaleString() }}({{ characters.tax_included }})</p></div>
            </div>

            <div v-if="goods_flag==='1'">
                <div class="cart_subtit">{{ characters.destination }}</div>
                <div v-if="addressFlag" class="to_addres"><p>〒{{ member_info.postnum + ' ' + member_info.address }}</p><p>{{ member_info.name }} {{ characters.honorific_title }}</p></div>
                <div v-if="!addressFlag" class="to_addres"><p>{{ characters.destination_empty }}</p><a href="/myInfo1">{{ characters.edit_member_info }}</a></div>
            </div>
            <div class="confirm" v-if="0 < cart.length">
                <button type="submit" @click="checkAddress()">{{ characters.settle }}</button>
            </div>
            <div class="to_store"><a href="/store">{{ characters.back_to_store }} ({{ characters.not_settling }})</a></div>

        </section>

        <div v-show="showContent">
            <transition name="modal">
                    <div class="modal-mask">
                        <div class="modal-wrapper" @click.self="closeModal()">
                            <div class="modal-container">
                                <div class="modal-header">
                                    <h3>{{ characters.choice_how_to_pay }}</h3>
                                </div>
                                <div class="modal-body">
                                    <div class="how-to-pay-kind screen-transition" v-for="pay_kind in pay_kinds" @click.once="pay(pay_kind)">
                                        <div class="pay-way" v-if="pay_kind!='paypal'">{{ characters[pay_kind] }}</div>
                                        <div class="button-image" v-if="pay_kind!='paypal'">
                                            <form :id="pay_kind" target="_top">
                                                <input type="hidden" name="_token" :value="csrf_token">
                                                <img src="/image/icons/next.png">
                                            </form>
                                        </div>

                                        <div class="pay-way" v-if="pay_kind=='paypal'">
                                            <div id="paypal-button-container"></div>
                                            <div id="paypal-error-message"></div>
                                        </div>

                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
            </transition>
        </div>

    </div>
</template>

<script>
    export default {
        name: "purchase-confirm",
        props: ['csrf_token', 'goods_flag', 'order_site', 'useable_payment', 'item_type_view_status', 'otanishinjiro_access_status', 'json_characters'],
        data: function () {
            return {
                cart: [],
                sum_yen: 0,
                sum_num: 0,
                member_info: [],
                showContent: false,
                credit_info: [],
                alipay_info: [],
                wechat_info: [],
                addressFlag: true,
                soldout_flag: false,
                characters: Object,
                delivery_fee: 0,
                pay_kinds: [],
                request_flag: false,
            }
        },
        mounted() {
            axios.default
                .get('/cart/get')
                .then(response => {
                    this.cart = response.data;
                    for(let item in this.cart) {
                        if(this.cart[item].zero_flag == 1) {
                            this.cart[item].price = 0;
                        } else {
                            this.sum_yen += this.cart[item].price*this.cart[item].num;
                        }
                        this.sum_num += this.cart[item].num;
                        if(this.cart[item].soldout_flag == 1) {
                            this.soldout_flag = true;
                        }
                    }
                });
            axios.default
                .post('/member/info/get')
                .then(response => {
                    this.member_info = response.data;
                    for(let key in this.member_info){
                        if(key == 'tax') continue;
                        if(key == 'nickname') continue;
                        let data = this.member_info[key];
                        if(data==null || data=='' || data==' ' || data=='  ') {
                            this.addressFlag = false;
                            break;
                        }
                    }
                });
            axios.default
                .post('/delivery_fee/get')
                .then(response => {
                    let res = response.data;
                    if(this.goods_flag==='1' && this.addressFlag==true) {
                        this.delivery_fee = res.delivery_fee;
                    }
                });
            this.characters = JSON.parse(this.json_characters);
            this.pay_kinds = JSON.parse(this.useable_payment);
        },
        methods: {
            openModal: function() {
                if(this.soldout_flag) {
                    alert(this.characters.remove_soldout_items);
                } else {
                    this.showContent=true;
                }
            },
            closeModal: function() {
                this.showContent=false;
            },
            checkAddress: function() {
                if(this.goods_flag!=='0' && !this.addressFlag) {
                    alert(this.characters.destination_empty);
                } else if(this.sum_yen + this.delivery_fee == 0) {
                    axios.default
                        .post('/purchase/pay', {pay_kind: 'free'})
                        .then(response => {
                            let res = response.data;
                            if(res.err != '') {
                                alert(this.characters[res.err]);
                            } else {
                                location.href='/purchase/end';
                            }
                        });
                } else {
                    this.openModal();
                }
            },
            pay: function(pay_kind) {
                if(this.request_flag) {
                    return;
                }
                this.request_flag=true;
                let form = document.forms[pay_kind];
                const gmo = ['credit', 'linepay', 'docomo', 'au', 'softbank'];
                const deferred = ['daibiki', 'bank_transfer', 'mail_send'];
                const deferred_use_flag = deferred.includes(pay_kind)?true:false;
                let site = gmo.includes(pay_kind)?'credit':pay_kind;
                form.action = this.order_site+'/payment_'+site+'.php';
                form.method = 'POST';
                axios.default
                    .post('/purchase/pay', {pay_kind: pay_kind})
                    .then(response => {
                        let data = response.data;
                        if(data['err']) {
                            if(data['err'] == 'sold_out') {
                                alert(this.characters.remove_soldout_items);
                            } else {
                                alert(this.characters[data['err']]);
                            }
                            location.href='/purchase/confirm';
                        } else {
                            if(deferred_use_flag) {
                                location.href='/purchase/end';
                                return;
                            }
                            for(const key in data) {
                                form.innerHTML+='<input type="hidden" name="'+key+'" value="'+response.data[key]+'">';
                            }
                            form.submit();
                        }
                    });
            },
        }
    }
</script>

<style scoped>
</style>
